import {clsx} from "clsx";

import React, {useState} from "react";
import popupStore from "../../../store/popupStore";
import ImageBasic from "../../Common/Image/ImageBasic";
import IMG from "../../../constants/image";
import {ORDER_STATUS, VARIANT} from "../../../constants";
import Button from "../../Common/Button";
import {fetchRefundOrder} from "../../../services/orderServices";
import appStore from "../../../store/appStore";
import Input from "../../Common/Input";
import {useSyncOrderAfterStatusChange} from "../../../hooks/useSyncOrderAfterStatusChange";

const FormRefund = ({orderId, phoneNumber}) => {
  const syncOrderAfterStatusChange = useSyncOrderAfterStatusChange();
  const {setPopup, setPopupMobile} = popupStore()
  const {setActiveTab} = appStore()
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!reason) return setError('Vui lòng nhập lý do muốn hoàn hàng')
    fetchRefundOrder({orderId, reason}).then((res) => {
      if (res?.data?.message === 'success') {
        syncOrderAfterStatusChange(orderId, ORDER_STATUS.ORDER_REFUND, {
          afterFetchCounts: () => setActiveTab(ORDER_STATUS.ORDER_REFUND),
        }).then(() => {
          setPopupMobile({})
          setPopup({})
          setReason('');
        })
      }
    })
  }
  const onHandleContact = (phoneNumber) => {
    if (phoneNumber) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(`Call: ${phoneNumber}`);
      } else window.location.href = `tel:${phoneNumber}`;
    }
    setPopup({})
  };
  return (
    <div
      className={clsx('flex text-black text-center flex-col gap-5 bg-white justify-center items-center w-80')}>
      <div className='flex items-center text-base font-bold space-x-2'>
        <ImageBasic src={IMG.icon.documentCancel}/>
        <div>Xác nhận hoàn hàng</div>
      </div>
      <div className='text-[#9E9E9E] text-xs'>Bạn chắc chắn muốn hoàn hàng này?</div>
      <div className='text-xs text-left text-[#9E9E9E]'>Vui lòng liên hệ với người mua hàng trước khi xác nhận
        hoàn hàng
      </div>
      <Input
        value={reason}
        error={error}
        setError={setError}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Lý do hoàn hàng"
        className="w-full p-3 border text-sm bg-white border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
      />
      <Button
        onClick={handleSubmit}
        className='w-full mt-1' variant={VARIANT.PRIMARY}>
        Xác nhận
      </Button>
      <Button
        variant={VARIANT.SECONDARY}
        className='!w-fit bg-transparent text-[#197D55] underline hover:border-none text-sm'
        onClick={() => onHandleContact(phoneNumber)}>
        Liên hệ người mua
      </Button>
    </div>
  )
}
export default FormRefund;
